import React, { useContext } from "react";
import { Link } from "react-router";
import { CSContext } from "../contexts/CSContext";
import { areObjectsIdentical } from "Pages/GMS/ISR/Components/RuleComponents/helper";
import { EMPTY_PIVOT_ELEMENT } from "../constants/CSConstants";
import Typography from "Components/DesignSystem/Typography/Typography";
import Button from "Components/DesignSystem/Button/Button";
import { ArrowLeft } from "Components/DesignSystem/Iconography/Icons";

/**
 * The weightage editor's header — DS `Typography`/`Button` since 2026-09-08 (was a
 * `tw-text-black` 20px label and a `button-style` CTA; the `heading-2`+`h1` pairing
 * is the enforced page-title grammar). The back control stays a react-router `Link`
 * (it navigates AND resets `CSContext` state), now drawing the DS `ArrowLeft` in
 * place of the baked-navy `LeftVectorIcon`. The action button's disabled expression
 * is untouched.
 */
const CSConfigHeader = ({ onCLickFunction, linkTo, label, buttonName, childComponent, showBackButton, mode, disabledCreateButton }: CSConfigPropType) => {
    const { resetState, pivotVersionList, pivotList } = useContext(CSContext)

    return (
        <>
            <div className={`tw-px-[21px] tw-pt-[12px] tw-flex tw-justify-between tw-items-center tw-gap-3`}>
                {showBackButton ? (
                    <Link
                        to={linkTo}
                        onClick={() => resetState()}
                        aria-label="Back"
                        data-testid="config-header-back-link"
                        className="tw-flex tw-items-center tw-justify-center tw-w-8 tw-h-8 tw-shrink-0 tw-rounded-ctl tw-text-ink hover:tw-bg-surface-hover-strong"
                    >
                        <ArrowLeft />
                    </Link>
                ) : null}
                <div className={`tw-flex tw-flex-col tw-items-start tw-flex-1 tw-min-w-0`}>
                    {/* § 285a — capped at the shared 32rem so a long config name cannot grow into the
                      action button beside it. See RuleHeader for the reasoning. */}
                    <Typography variant="display" as="h1" className="tw-text-ink tw-truncate tw-max-w-[32rem]">
                        {label}
                    </Typography>
                </div>
                {childComponent ? childComponent : null}
                <div className={`tw-flex`}>
                    <div className={`tw-ps-3`}>
                        <Button variant="primary" onClick={onCLickFunction} data-testid="config-header-action-btn"
                            disabled={disabledCreateButton || (buttonName !== "Create" && mode === "create" &&
                                pivotList && areObjectsIdentical(pivotList[0], EMPTY_PIVOT_ELEMENT) || (buttonName !== "Create" && pivotVersionList?.length > 0))}
                        >
                            {buttonName}
                        </Button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CSConfigHeader;
